export function groupLedgerEvents(events) {
  const result = [], days = new Map();
  for (const event of events) {
    const salary = event.details?.source === 'personnel-compensation' || ['Categoría salarial', 'Tarifas de operaciones'].includes(event.type);
    const day = String(event.date || '').slice(0, 10);
    if (!salary || !day) { result.push(event); continue; }
    let group = days.get(day);
    if (!group) {
      group = { id: `salary-day-${day}`, date: event.date, type: 'Información salarial', entries: [] };
      days.set(day, group);
      result.push(group);
    }
    group.entries.push(event);
  }
  return result;
}
